var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item',{attrs:{"href":_vm.link}},[_vm._v(" "+_vm._s(_vm.link_text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }